export const headerdata = [
  {
    id: 1,
    item: 'home',
    to: '/',
  },
  {
    id: 2,
    item: 'showtimes',
    to: '/showtimes',
  },
  {
    id: 3,
    item: 'about us',
    to: '/about-cineplex',
  },

  {
    id: 4,
    item: 'career',
    to: '/career',
  },

  {
    id: 5,
    item: 'contacts',
    to: '/contacts',
  },
  {
    id: 6,
    item: 'download app',
    to: '/download',
  },
];
export const subHeaderdata = [
  {
    id: 1,
    item: 'Popular',
    to: '/movies/popular',
  },
  {
    id: 2,
    item: 'Up Coming',
    to: '/movies/upcoming',
  },
  {
    id: 3,
    item: 'Top Rated',
    to: '/movies/top_rated',
  },
];
